import { render, staticRenderFns } from "./OrgContacts.vue?vue&type=template&id=2a97fda2"
import script from "./OrgContacts.vue?vue&type=script&lang=js"
export * from "./OrgContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/3e17078e833b83b1/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a97fda2')) {
      api.createRecord('2a97fda2', component.options)
    } else {
      api.reload('2a97fda2', component.options)
    }
    module.hot.accept("./OrgContacts.vue?vue&type=template&id=2a97fda2", function () {
      api.rerender('2a97fda2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/AccountSettings/OrgContacts.vue"
export default component.exports